import React from 'react'

import FormattedDateTime from 'syft-acp-core/components/FormattedDateTime'

import { isLateBooking, startMsOf } from './helpers'
import { BookingCompensationDecision, WorkerJobBooking } from './types'

// The reason determines each shift's starting CH value. Keep the whole row disabled
// until a reason is selected so the first visible state already reflects that policy.
export const ShiftRow = ({
  booking,
  checked,
  compensation,
  reasonSelected,
  onToggle,
  onChangeCH,
  onChangeFC,
}: {
  booking: WorkerJobBooking
  checked: boolean
  compensation: BookingCompensationDecision
  reasonSelected: boolean
  onToggle: (shiftId: number) => void
  onChangeCH: (booking: WorkerJobBooking, enabled: boolean) => void
  onChangeFC: (booking: WorkerJobBooking, enabled: boolean) => void
}) => {
  const startMs = startMsOf(booking)
  const isLate = isLateBooking(booking)

  return (
    <div className="shift-row">
      <label className="shift-selection">
        <input
          type="checkbox"
          checked={checked}
          disabled={!reasonSelected}
          onChange={() => onToggle(booking.shift_id)}
        />{' '}
        {/* @ts-expect-error legacy component types */}
        <FormattedDateTime
          value={startMs}
          format={{ day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }}
        />
      </label>
      {isLate && <span className="late-badge">starts in &lt;24h · late</span>}
      <span className="compensation-controls">
        <label>
          <input
            aria-label={`Compensation Hours (CH) for shift ${booking.shift_id}`}
            title="Compensation Hours (CH)"
            type="checkbox"
            checked={compensation.ch}
            disabled={!checked || !reasonSelected}
            onChange={event => onChangeCH(booking, event.target.checked)}
          />{' '}
          CH
          {compensation.chDefaulted && <span className="auto-selected-badge">Auto-selected</span>}
        </label>
        <label>
          <input
            aria-label={`Flex Compensation (FC) for shift ${booking.shift_id}`}
            title="Flex Compensation (FC)"
            type="checkbox"
            checked={compensation.fc}
            disabled={!checked || !reasonSelected}
            onChange={event => onChangeFC(booking, event.target.checked)}
          />{' '}
          FC
        </label>
      </span>
    </div>
  )
}
